import { cn } from '~/lib/utils';
import googleMeetIcon from '~/landing_page/Assets/GoogleMeet.png';
import avatar1 from '~/landing_page/Assets/Avatar1.png';
import avatar2 from '~/landing_page/Assets/Avatar2.png';
import avatar3 from '~/landing_page/Assets/Avatar3.png';
import avatar4 from '~/landing_page/Assets/Avatar4.png';
import styles from './WidgetCard.module.css';

export interface CalendarCardProps {
  className?: string;
  title?: string;
  time?: string;
  avatarCount?: number;
}

export const CalendarCard = ({
  className,
  title = 'Sprint Review',
  time = 'Today, 3:00 PM',
  avatarCount = 5,
}: CalendarCardProps) => {
  const avatars = [avatar1, avatar2, avatar3, avatar4];

  return (
    <div className={cn(styles.card, className)} style={{ height: 88 }}>
      <div className={styles.row}>
        <img src={googleMeetIcon} className={styles.icon} alt="Google Meet" />
        <div className={styles.container}>
          <div className={styles.metaContainer}>
            <p className={styles.title}>{title}</p>
            <p className={cn(styles.text, styles.textMuted)}>{time}</p>
          </div>
          <div className={styles.avatarGroup}>
            {avatars.map((src, i) => (
              <img key={i} src={src} className={styles.avatar} alt={`Avatar ${i + 1}`} />
            ))}
            {avatarCount > avatars.length && (
              <div className={styles.avatarPlaceholder}>
                +{avatarCount}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

CalendarCard.displayName = 'CalendarCard';
